<script setup lang="ts">
import type { DRPartialProject, Project } from "@/types/projects.types";
import EditProjectModal from "./EditProjectModal.vue";
import { useUpdateProject } from "@/stores/queries";
import { ref } from "vue";
import DRDropdownItem from "../UI/DRDropdownItem.vue";
import DRBtnIcon from "../UI/DRBtnIcon.vue";

const props = withDefaults(
  defineProps<{
    project: DRPartialProject | Project;
    readonly?: boolean;
    hideOpenOption?: boolean;
  }>(),
  {
    readonly: false,
    hideOpenOption: false,
  }
);

defineEmits<{
  (e: "openProject"): void;
}>();

const editing = ref(false);

const { mutateAsync: mutateUpdateProject, isPending } = useUpdateProject();

const updateProject = async (payload: { name: string; color: string }) => {
  mutateUpdateProject(
    {
      id: props.project.id,
      ...payload,
    },
    {
      onSuccess: () => {
        editing.value = false;
      },
      onError: (error) => {
        console.error("Error updating project:", error);
      },
    }
  );
};
</script>

<template>
  <el-dropdown trigger="click" @click.stop.prevent>
    <DRBtnIcon
      :size="30"
      icon="bi-three-dots"
      variant="flat"
      @click.stop.prevent
    />

    <template #dropdown>
      <el-dropdown-menu>
        <DRDropdownItem
          v-if="!hideOpenOption"
          @select="
            $router.push({ name: 'project', params: { id: props.project.id } })
          "
          icon="bi-folder2-open"
          :label="$t('dashboard:projects.actions.open')"
        />
        <DRDropdownItem
          @select="editing = true"
          :disabled="readonly"
          icon="bi-pencil"
          :label="$t('dashboard:projects.actions.rename')"
        />
      </el-dropdown-menu>
    </template>
  </el-dropdown>

  <EditProjectModal
    v-model="editing"
    :project="project"
    :loading="isPending"
    name-only
    @confirm="updateProject"
  />
</template>

<style lang="scss" scoped></style>
